export default __webpack_public_path__ + "static/media/CAKE.070b6132.svg";